import { useEffect, useState } from 'react';

import { FeatureFlag } from 'src/shared/constants';
import { isBrowser, isServer } from 'src/shared/helpers/environment';
import { useTreatment } from 'src/shared/hooks';
import { isEnabled } from 'src/shared/telemetry/featureFlag';

export const showOnboarding = (
  isBeacon: boolean | null,
  isOnboardingTreatmentEnabled: boolean,
  isInternalOnboardingTestOn?: boolean,
) => {
  if (isBeacon) return false;
  return isInternalOnboardingTestOn || isOnboardingTreatmentEnabled;
};

export const useOnboardingSplit = () => {
  // TODO: Used for testing, will be removed
  const isBrowserLoaded = isBrowser();

  const [isInternalOnboardingTestOn, setIsInternalOnboardingTestOn] = useState<
    undefined | boolean
  >(undefined);

  // Annoying way of checking if the user is on the beacon login page because beacon isn't being sunset until March 2024
  const [isBeacon, setIsBeacon] = useState<boolean | null>(null);

  useEffect(() => {
    if (isBrowserLoaded) {
      setIsInternalOnboardingTestOn(!!localStorage.getItem('onboarding-test'));
      setIsBeacon(window.location.hostname.includes('beacon'));
    }
  }, [isBrowserLoaded]);

  const onboardingLoginTreatment = useTreatment(
    FeatureFlag.Web.ONBOARDING_P1_LOGIN,
  );

  const onboardingSignupTreatment = useTreatment(
    FeatureFlag.Web.ONBOARDING_P1_SIGN_UP,
  );

  const showOnboardingSignup = showOnboarding(
    isBeacon,
    isEnabled(onboardingSignupTreatment),
    isInternalOnboardingTestOn,
  );

  const showOnboardingLogin = showOnboarding(
    isBeacon,
    isEnabled(onboardingLoginTreatment),
    isInternalOnboardingTestOn,
  );

  const isLoading =
    isServer() ||
    typeof isInternalOnboardingTestOn === 'undefined' ||
    typeof onboardingLoginTreatment === 'undefined';

  return { isLoading, showOnboardingLogin, showOnboardingSignup };
};
